import { Component } from '@angular/core';
import { BaseDialogComponent } from '@shared/library/components/base-dialog/base-dialog.component';
import { TypeDialogEnum } from '@shared/library/configs/enums/type-dialog-enum';

@Component({
  selector: 'app-error-dialog',
  standalone: true,
  imports: [BaseDialogComponent],
  templateUrl: './error-dialog.component.html',
  styleUrl: './error-dialog.component.scss'
})
export class ErrorDialogComponent {
  public type: TypeDialogEnum = TypeDialogEnum.ERROR;
}
